import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white py-4">
      <div className="container mx-auto flex justify-between items-center">
        <div className="text-sm">
          <p>
            <span className="text-lg font-medium">Cere</span> | © 2023 Cerebrum
            Technologies | All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
